import {
  CommonModule,
  CurrencyPipe,
  registerLocaleData,
} from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import localePt from "@angular/common/locales/pt";
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from "@angular/core";
import { AngularFireModule } from "@angular/fire";
import { AngularFireMessagingModule } from "@angular/fire/messaging";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouteReuseStrategy } from "@angular/router";
import { ServiceWorkerModule } from "@angular/service-worker";
import { BarcodeScanner } from "@ionic-native/barcode-scanner/ngx";
import { Camera } from "@ionic-native/camera/ngx";
import { EmailComposer } from "@ionic-native/email-composer/ngx";
import { FileOpener } from "@ionic-native/file-opener/ngx";
import { File } from "@ionic-native/file/ngx";
import { HTTP } from "@ionic-native/http/ngx";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { CalendarModule } from "ion2-calendar";
import { IonicSelectableModule } from "ionic-selectable";
import { SimpleMaskModule } from "ngx-ion-simple-mask";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CompartilhadoModule } from "./componentes/compartilhado.module";
import { JwtInterceptor } from "./interceptors/jwt.interceptor";
import { ConsultoresModalPage } from "./paginas/consultores-modal/consultores-modal.page";
import { ConsultoresRelatorioFiltroPage } from "./paginas/consultores-relatorio-filtro/consultores-relatorio-filtro.page";
import { ParceiroEditGuiaPage } from "./paginas/parceiro-edit-guia/parceiro-edit-guia.page";
import { ParceiroGuiasFiltroPage } from "./paginas/parceiro-guias-filtro/parceiro-guias-filtro.page";
import { EditarEmpresaPage } from "./paginas/parceiros-modal/editar-empresa.page";
import { ProcedimentoModalPage } from "./paginas/procedimento-modal/procedimento-modal.page";
import { TipoModalPage } from "./paginas/tipo-modal/tipo-modal.page";
import { ModalCategoriasEmpresasPage } from "./paginas/modal-categorias-empresas/modal-categorias-empresas.page";
import { ModalLogosEmpresasPage } from "./paginas/modal-logos-empresas/modal-logos-empresas.page";

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    EditarEmpresaPage,
    ConsultoresModalPage,
    ProcedimentoModalPage,
    TipoModalPage,
    ParceiroEditGuiaPage,
    ParceiroGuiasFiltroPage,
    ConsultoresRelatorioFiltroPage,
    ModalCategoriasEmpresasPage,
    ModalLogosEmpresasPage,
  ],
  entryComponents: [
    EditarEmpresaPage,
    ConsultoresModalPage,
    ProcedimentoModalPage,
    TipoModalPage,
    ParceiroEditGuiaPage,
    ParceiroGuiasFiltroPage,
    ConsultoresRelatorioFiltroPage,
    ModalCategoriasEmpresasPage,
    ModalLogosEmpresasPage,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CompartilhadoModule,
    HttpClientModule,
    IonicModule.forRoot({
      mode: "ios",
      backButtonText: "Voltar",
    }),
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    IonicSelectableModule,
    CalendarModule,
    ServiceWorkerModule.register("combined-sw.js", {
      enabled: environment.production,
      registrationStrategy: "registerImmediately",
    }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    BrowserAnimationsModule,
    SimpleMaskModule,
  ],
  providers: [
    BarcodeScanner,
    HTTP,
    FileOpener,
    File,
    Camera,
    EmailComposer,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    CurrencyPipe,
    {
      provide: LOCALE_ID,
      useValue: "pt-BR",
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
